// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".property-name{\n    color:#034C8C;\n    font-size: 40px;\n    padding-bottom: 10px;\n}", "",{"version":3,"sources":["webpack://./src/screens/assetDashboard/PropertyWaterSavings.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,oBAAoB;AACxB","sourcesContent":[".property-name{\n    color:#034C8C;\n    font-size: 40px;\n    padding-bottom: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
